import { render, staticRenderFns } from "./ActionButtons.vue?vue&type=template&id=5bd51d5d"
import script from "./ActionButtons.vue?vue&type=script&lang=js"
export * from "./ActionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports